export default () => ({
	__type: "PopoverGroup",
	popoverGroup: null,
	init() {
		this.popoverGroup = this.$el;
		let t = e => {
			document.body.contains(this.$el) ? e.target instanceof Element && !this.$el.contains(e.target) && window.dispatchEvent(new CustomEvent("close-popover-group", {
				detail: this.$el
			})) : window.removeEventListener("focus", t, !0)
		};
		window.addEventListener("focus", t, !0)
	}
})
